import React, {Component} from 'react';
import styles from "./zipingList.module.css";
import back from '../../img/ic_back.png';

import defaultImg from '../../img/bee.png';
import first from '../../img/first.png';
import second from '../../img/second.png';
import third from '../../img/third.png';
import icStar from '../../img/ic_star_selected.png';
import icCaiji from '../../img/ic_caiji_green.svg';

const ZipingList = props => (

    <div className={styles.root}>
        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.closeZipingListModal}/>
            <div className={styles["modal-title"]}>学生自我评价</div>
        </div>

        <div className={styles.container}>

            <div className={styles["container-rank"]}>
                <img className={styles["img-rank"]} src={icStar}/>
                <div>学生自评分数</div>
            </div>

            <div className={styles["container-paiming"]}>

                {props.studentList.length > 0 ?

                    <div>
                        <table className={styles.table}>
                            <thead>
                            <tr>
                                <td className={styles.td0}>姓名</td>
                                <td className={styles.td0}>总分</td>
                                {/*<td className={styles.td0}>点赞总计</td>*/}
                                {/*<td className={styles.td0}>品德</td>*/}
                                {/*<td className={styles.td0}>思维</td>*/}
                                {/*<td className={styles.td0}>艺术</td>*/}
                                {/*<td className={styles.td0}>体育</td>*/}
                                {/*<td className={styles.td0}>人文</td>*/}
                                {/*<td className={styles.td0}>科创</td>*/}

                                {
                                    props.zhibiaoList.map((item, index, array) => {
                                        return (
                                            <td className={styles.td0}>{item.name}</td>
                                        )
                                    })
                                }

                            </tr>
                            </thead>
                            {
                                props.studentList.map((item, index, array) => {
                                    return (
                                        <tbody>
                                        <tr>

                                            <td className={styles["item-name"]}
                                                onClick={props.chakanInfo.bind(null, item.pid, item.name,item.face_imgurl)}>

                                                <div className={styles["item-info"]}>
                                                    <img className={styles["img-touxiang"]} src={item.img}
                                                         onError={props.handleImageErrored.bind(this, index)}/>
                                                    <div>
                                                        {item.name}
                                                    </div>
                                                    {item.face_imgurl==''||item.face_imgurl==null?null:
                                                        <img className={styles["img-caiji"]} src={icCaiji}/>
                                                    }

                                                </div>

                                            </td>
                                            <td>{item.huizhang}</td>
                                            <td>{item.dianzan}</td>
                                            <td>{item.huizhang_xueyuan[0].value}</td>
                                            <td>{item.huizhang_xueyuan[1].value}</td>
                                            <td>{item.huizhang_xueyuan[2].value}</td>
                                            <td>{item.huizhang_xueyuan[3].value}</td>
                                            <td>{item.huizhang_xueyuan[4].value}</td>
                                            <td>{item.huizhang_xueyuan[5].value}</td>

                                        </tr>
                                        </tbody>
                                    )
                                })
                            }

                        </table>
                    </div>

                    :
                    <div>
                        <table className={styles.table}>
                            <thead>
                            <tr>
                                <td className={styles.td0}></td>
                                <td className={styles.td0}>姓名</td>
                                <td className={styles.td0}>总分</td>
                                {/*<td className={styles.td0}>点赞总计</td>*/}
                                {/*<td className={styles.td0}>品德</td>*/}
                                {/*<td className={styles.td0}>思维</td>*/}
                                {/*<td className={styles.td0}>艺术</td>*/}
                                {/*<td className={styles.td0}>体育</td>*/}
                                {/*<td className={styles.td0}>人文</td>*/}
                                {/*<td className={styles.td0}>科创</td>*/}

                                {
                                    props.zhibiaoList.map((item, index, array) => {
                                        return (
                                            <td className={styles.td0}>{item.name}</td>
                                        )
                                    })
                                }
                            </tr>
                            </thead>

                            <thead>
                            <tr>
                                <td className={styles.td0}></td>
                                <td className={styles.td0}></td>
                                <td className={styles.td0}></td>
                                <td className={styles.td0}></td>
                                <td className={styles.td00}>暂无数据</td>

                                <td className={styles.td0}></td>
                                <td className={styles.td0}></td>
                                <td className={styles.td0}></td>
                                <td className={styles.td0}></td>
                            </tr>
                            </thead>
                        </table>
                    </div>
                }

            </div>

        </div>

    </div>

)

export default ZipingList;
